import { Modal, Button } from '../ui';
import QuestionDetail from './QuestionDetail';

// Modal viewer over a list of questions with prev/next navigation.
// Replaces the old QuestionListModal and the ad-hoc exam details modal.
export default function QuestionBrowserModal({ open, onClose, title, questions, index, onNavigate }) {
  if (!open || index == null || !questions?.length) return null;
  const question = questions[Math.min(index, questions.length - 1)];
  return (
    <Modal title={title || 'Question'} onClose={onClose}>
      <div className="question-detail-nav">
        <Button variant="secondary" onClick={() => onNavigate(index - 1)} disabled={index <= 0}>
          ← Previous
        </Button>
        <span>Question {index + 1} / {questions.length}</span>
        <Button variant="secondary" onClick={() => onNavigate(index + 1)} disabled={index >= questions.length - 1}>
          Next →
        </Button>
      </div>
      <QuestionDetail question={question} />
    </Modal>
  );
}
